import React from "react";
import TablePagination from '@mui/material/TablePagination';
import Grid from '@mui/material/Grid';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import UserForm from './userform.jsx';
import AlertDialog from './alertdlg.jsx';

import StdButton from './stdbutton.jsx';
import SvgIcon from '@mui/material/SvgIcon';
import TextField from "@mui/material/TextField";


class Users extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: [],
            page: { rowsPerPage: 10 },
            dlgOpen: false,
            promptOpen: false,
            alertOpen: false,
            alertMessage: null,
            selectedUser: { isLoaded: false, isNew: false, data: {} },
            filterOn: false,
            filterValue: ""
        };
        this.setState = this.setState.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this);
        this.onDeleteResult = this.onDeleteResult.bind(this);

        this.handleClose = this.handleClose.bind(this);
        this.handleSave = this.handleSave.bind(this);

        this.handleLoadUser = this.handleLoadUser.bind(this);
        this.onLoadResult = this.onLoadResult.bind(this);

        this.openPrompt = this.openPrompt.bind(this);
        this.closePrompt = this.closePrompt.bind(this);

        this.closeAlert = this.closeAlert.bind(this);
        this.onSaveResult = this.onSaveResult.bind(this);

        this.filterSwitch = this.filterSwitch.bind(this);
        this.filterSubmit = this.filterSubmit.bind(this);
        this.changeData = this.changeData.bind(this);

    }



    componentDidMount() {
        getPage("/web/users", {}, this.setState);
    }

    onChangePage(event, pageNum){
        let rowsPerPage = this.state.page.rowsPerPage;
        this.setState({ isLoaded: false });
        getPage("/web/users", { page: pageNum, size: rowsPerPage, filter: this.state.filterValue }, this.setState);
    }

    onChangeRowsPerPage(event){
        this.setState({ isLoaded: false });
        getPage("/web/users", { size: event.target['value'], filter: this.state.filterValue }, this.setState);
    }

    changeData(e){
        this.setState({ filterValue: e.target.value });
    }

    filterSwitch(){
        if (this.state.filterOn) {
            this.setState({ filterOn: false });
        } else {
            this.setState({ filterOn: true });
        }
    }

    filterSubmit(){
        let rowsPerPage = this.state.page.rowsPerPage;
        this.setState({ isLoaded: false });
        getPage("/web/users", { size: rowsPerPage, filter: this.state.filterValue }, this.setState);
    }

    handleOpen(email){
        if(email) {
            this.setState({
                dlgOpen: true,
                selectedUser: { isLoaded: false, isNew: false, data: {} }
            });
            this.handleLoadUser(email);
        } else {
            this.setState({
                dlgOpen: true,
                selectedUser: { isLoaded: true, isNew: true, data: {} }
            });
        }
    }

    handleClose() {
        this.setState({
            dlgOpen: false,
            selectedUser: { isLoaded: false, isNew: false, data: {} }
        });
    }

    handleSave() {
        this.setState({
            dlgOpen: false
        });
    }

    handleLoadUser(email) {
        getData("/web/users/" + encodeURIComponent(email), this.onLoadResult);
    }

    onLoadResult(result) {
        if (result.isLoaded) {
            this.setState({ selectedUser: { isLoaded: true, isNew: false, data: result.data }});
        } else {
            this.setState({ selectedUser: { isLoaded: true, isNew: false, error: result.error }});
        }
    }

    onDeleteResult(state){
        if (state.isDone) {
            getPage("/web/users", { page: this.state.page.pageNum, size: this.state.page.rowsPerPage, filter: this.state.filterValue }, this.setState);
        } else {
            this.setState({ isLoaded: true, error: state.error });
        }
    }

    closePrompt(){
        this.setState({ dlgOpen: true, promptOpen: false });
    }

    openPrompt(){
        this.setState({ dlgOpen: false, promptOpen: true });
    }

    closeAlert(){
        this.setState({ dlgOpen: true, alertOpen: false, alertMessage: null });
    }

    onSaveResult(result) {
        if (result.isDone) {
            this.setState({ dlgOpen: false, isLoaded: false, selectedUser: { isLoaded: false, isNew: false, data: {} }});
            getPage("/web/users", { page: this.state.page.pageNum, size: this.state.page.rowsPerPage, filter: this.state.filterValue }, this.setState);
        } else {
            var user = this.state.selectedUser;
            user['isLoaded']=true;
            if (result.fieldErrors) {
                var errors = {};
                result.fieldErrors.forEach(error => { errors[error.fieldName]=error.message; });
                user['fieldErrors']=errors;
                this.setState({ dlgOpen: true, alertOpen: false, selectedUser: user});
            } else {
                this.setState({ dlgOpen: false, alertOpen: true, alertMessage: result.error.message, selectedUser: user});
            }
        }
    }


    render() {
        const { error, isLoaded, items } = this.state;
        if (error) {
            return <div style={{ background: '#ffffff', border: '2px solid #dfdfdf' }}>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div className="text-center" style={{ background: '#ffffff', border: '2px solid #dfdfdf' }}><div className="spinner-border m-5" /></div>;
        } else {
            if (this.state.selectedUser.data.email) {
                var warningText = this.state.selectedUser.data.firstName + " " + this.state.selectedUser.data.lastName + " (" + this.state.selectedUser.data.email + ") " +
                                  "will no longer have access to any PrecisionFlight Tower or PrecisionAnalytics Tower applications.";
            } else {
                var warningText = "";
            }
            return (
                <div style={{ background: '#ffffff', border: '2px solid #dfdfdf' }}>
                    <Grid container spacing={0}>
                        <Grid item xs={6} sm={6} style={{ padding: 20 }} onClick={this.filterSwitch}>
                            <h2>Users</h2>
                        </Grid>
                        <Grid item xs={6} sm={6} style={{ padding: 20, textAlign: "right" }}>
                            <StdButton label="Add User" icon="person_add" onClick={() => { this.handleOpen(null); }}/>
                            <UserForm open={this.state.dlgOpen} user={this.state.selectedUser} onClose={this.handleClose} onSaveResult={this.onSaveResult}/>
                            <AlertDialog open={this.state.alertOpen} title="Error" text={this.state.alertMessage} onConfirm={this.closeAlert}/>
                        </Grid>
                    </Grid>
                    { this.state.filterOn && (
                        <Grid container spacing={0}>
                            <Grid item xs={6} sm={6} style={{ padding: 20 }}>
                                <TextField
                                    id="filter" name="filter" label="Filter" value={this.state.filterValue} onChange={this.changeData} margin="normal" variant="outlined" fullWidth />
                            </Grid>
                            <Grid item xs={6} sm={6} style={{ padding: 20 }}>
                                <div style={{ marginTop: '16px', marginBottom: '8px' }}>
                                    <StdButton label="Submit" onClick={this.filterSubmit}/>
                                </div>
                            </Grid>
                        </Grid>
                    )}
                    <Table padding="dense">
                        <TableHead>
                        <TableRow>
                            <TableCell style={{width:'5%'}}>&nbsp;</TableCell>
                            <TableCell style={{width:'25%'}}>Name</TableCell>
                            <TableCell style={{width:'25%'}}>Email</TableCell>
                            <TableCell style={{width:'25%'}}>Role</TableCell>
                            <TableCell style={{width:'15%'}}>Status</TableCell>
                            <TableCell style={{width:'5%'}}>&nbsp;</TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        {items.map(user => (
                            <TableRow key={user.email}>
                                <TableCell>
                                    <SvgIcon onClick={() => { this.handleOpen(user.email); }}>
                                        <path fill="none" d="M0 0h24v24H0V0z"/><path d="M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                                    </SvgIcon>
                                </TableCell>
                                <TableCell>{user.firstName} {user.lastName}</TableCell>
                                <TableCell>{user.email}</TableCell>
                                <TableCell>{user.role}</TableCell>
                                <TableCell>{ user.blocked ? 'Inactive':'Active' }</TableCell>
                                <TableCell>
                                    <SvgIcon onClick={() => { this.handleOpen(user.email); }}>
                                        <path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z"/>
                                    </SvgIcon>
                                </TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[10, 20, 30]}
                        component="div"
                        count={this.state.page.totalElements}
                        rowsPerPage={this.state.page.rowsPerPage}
                        page={this.state.page.pageNumber}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page',
                        }}
                        onPageChange={this.onChangePage}
                        onRowsPerPageChange={this.onChangeRowsPerPage}
                    />
                </div>
            )
        }
    }
}


export default Users;